"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var FormatCurrency_1 = require("Utils/FormatCurrency");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var VariableChooserMenu = (function (_super) {
    __extends(VariableChooserMenu, _super);
    function VariableChooserMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.searchValue = "";
        _this.searchResults = [];
        _this.renderResults = function () {
            var currencyCode = _this.props.currencyCode;
            return _this.searchResults.map(function (variable) {
                return (react_1.default.createElement("div", { key: variable.getId(), className: "variable-chooser-menu__result", onClick: _this.selectVariable(variable) },
                    react_1.default.createElement("div", { className: "variable-chooser-menu__result-name" }, variable.name),
                    react_1.default.createElement("div", { className: "variable-chooser-menu__result-rate" },
                        (0, FormatCurrency_1.formatCurrency)(variable.defaultAmount, currencyCode),
                        " / ",
                        variable.unitName)));
            });
        };
        _this.openEditor = function () {
            _this.props.openEditor();
        };
        _this.search = function (event) {
            _this.searchValue = (event && event.target && event.target.value) || "";
            _this.searchResults = _this.throttledSearch(_this.searchValue);
        };
        _this.selectVariable = function (variable) {
            return function () {
                _this.props.selectVariable(variable);
            };
        };
        _this.throttledSearch = (0, lodash_1.throttle)(props.searchVariables, 200, { leading: true });
        _this.search();
        return _this;
    }
    VariableChooserMenu.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "variable-chooser-menu" },
            react_1.default.createElement("div", { className: "variable-chooser-menu__edit", onClick: this.openEditor },
                react_1.default.createElement("span", { className: "variable-chooser-menu__edit-description" }, "Create and manage all variables"),
                react_1.default.createElement(icons_1.ArrowRight, { className: "variable-chooser-menu__edit-arrow" })),
            react_1.default.createElement("div", { className: "variable-chooser-menu__search-container" },
                react_1.default.createElement("input", { className: "variable-chooser-menu__search-input", onChange: this.search, value: this.searchValue, type: "text", placeholder: "Find Variable" })),
            react_1.default.createElement("div", { className: "variable-chooser-menu__results" }, this.renderResults())));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], VariableChooserMenu.prototype, "searchValue", void 0);
    VariableChooserMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], VariableChooserMenu);
    return VariableChooserMenu;
}(react_1.default.Component));
exports.default = VariableChooserMenu;
